import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

export default function SalesTicker({ onSelect, reloadSignal }) {
  const [domains, setDomains] = useState([]);

  useEffect(() => {
    api.get("/domains/ticker").then((r) => setDomains(r.data.domains || [])).catch(() => {});
  }, [reloadSignal]);

  if (!domains.length) return null;

  const Group = () => (
    <div className="flex items-center shrink-0 pl-6">
      {domains.map((d, i) => (
        <span key={i} className="flex items-center shrink-0">
          <button
            onClick={() => onSelect && onSelect(d)}
            data-testid={`ticker-domain-${d.name}`}
            className="font-mono text-xs text-ink-dim/80 hover:text-gold tracking-wide transition-colors cursor-pointer"
          >
            {d.name}
          </button>
          <span className="w-1 h-1 rotate-45 bg-gold/40 mx-6" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="sales-ticker"
      className="sticky top-16 sm:top-20 z-40 bg-[var(--nav-bg)] backdrop-blur-md overflow-hidden py-3"
    >
      {/* Two identical groups + reversed animation = seamless left-to-right loop */}
      <div
        className="flex items-center whitespace-nowrap animate-marquee w-max"
        style={{ animationDuration: "38s" }}
      >
        <Group />
        <Group />
      </div>
    </div>
  );
}
